<template>
    <a-layout style="height:100%">
        <a-layout-header style="height:74px">
            <div class="header">
                <div class="logo">
                    <router-link to="/newHome">
                        <img src="@/assets/UniversityLogo.png" alt="">
                        <span>内蒙古基层治理数据中心</span>
                    </router-link>
                </div>
            </div>
        </a-layout-header>
        <router-view />
    </a-layout>
</template>

<script>
export default {
    
}
</script>
<style lang="scss">
@import '../../scss/analysis.scss';
</style>